/**
 *
 * StatusTag
 *
 */

import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import useStyles from './styles';

const StatusTag = ({ className, backgroundColor, color, status }) => {
  const classes = useStyles({ backgroundColor, color });

  return (
    <Typography className={`${classes.tagText} ${className}`} variant="body2">
      {status}
    </Typography>
  );
};

StatusTag.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  className: PropTypes.string,
  color: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};

export default memo(StatusTag);
